import { ActivitiesRequests } from '@/services/activities.requests'
import { APP_FACILITY_ID } from '@/config/environment'
import router from '@/router'
const activitiesService = new ActivitiesRequests()

const state = {
  categories: [],
  activities: [],
  listCategories:[],
  catalog: null,
  extendedActivity: null,
  capacityPerSlot: [],
}

const getters = {
  onlyCategoriesWithActivities: state => {
    var categoryIds = []
    state.activities.forEach(item => {
      item.activity.categoryIds.forEach(id => {
        if (!categoryIds.includes(id)) {
          categoryIds.push(id)
        }
      })
    })
    return state.categories.filter((item) => {
      return categoryIds.includes(item.id)
    })
  },
  activitiesByCategory: (state) => (categoryId) => {
    return state.activities.filter(item => {
      return item.activity.categoryIds.includes(categoryId)
    })
  },
  activityById: (state) => (id) => {
    return state.activities.find(item => {
      return item.activity.id === id
    })
  },
  productById: (state) => (id) => {
    var prod = state.catalog.products.find(item => {
      return item.product.id === id
    })
    if (prod) { return prod } else {
      state.catalog.categories.forEach(cat => {
        prod = cat.products.find(prod => {
          return prod.product.id === id
        })
      })
      if (prod) { return prod } else { return null }
    }
  },
  categoryById: (state) => (id) => {
    return state.catalog.categories.find(item => {
      return item.category.id === id
    })
  },
  currencies: (state) => {
    return state.extendedActivity ? state.extendedActivity.activity.currencies : null
  },
}

const actions = {
  listCategories ({ state }) {
    if (!APP_FACILITY_ID) {
      router.go(-1)
    } else if (state.categories.length === 0) {
      return new Promise((resolve, reject) => {
        activitiesService.listActivityCategories().then((activityCategories) => {
          state.categories = activityCategories
          resolve(activityCategories)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  listActivities ({ state, commit }, { categoryId }) {
    if (!APP_FACILITY_ID) {
      router.go(-1)
    } else if (!state.listCategories.includes(categoryId) && !state.listCategories.includes(null)) {
      return new Promise((resolve, reject) => {
        activitiesService.listActivities(categoryId).then((activities) => {
          var filteredList = activities.filter((item) => {
            return item.activity.active
          })
          const data = [...state.activities].concat(filteredList)
          const listCategoriesSearch = [...state.listCategories].concat(categoryId || null)
          state.listCategories = listCategoriesSearch
          commit('setActivities', data)
          resolve(filteredList)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },
  getActivity ({ state }, { id }) {
    return new Promise((resolve, reject) => {
      activitiesService.getActivity(id).then((extendedActivity) => {
        state.extendedActivity = extendedActivity
        resolve(extendedActivity)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  listCapacityPerSlot ({ state }, { id, save, since, until }) {
    return new Promise((resolve, reject) => {
      activitiesService.listCapacityPerSlot(id, since, until).then((capacityPerSlot) => {
        if (save) {
          state.capacityPerSlot = capacityPerSlot
        }
        resolve(capacityPerSlot)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getCatalog ({ state }, { id }) {
    return new Promise((resolve, reject) => {
      state.catalog = null
      activitiesService.getCatalog(id).then((catalog) => {
        state.catalog = catalog
        resolve(catalog)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

const mutations = {
  setActivities (state, activities) {
    state.activities = activities
  },
  resetActivityData (state) {
    state.extendedActivity = null
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
